exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#app{height:100%\n}\n.is-relative{position:relative\n}\n.monospace{font-family:monospace\n}\n.truncate{max-width:100px;white-space:nowrap;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis\n}\n.tag{position:relative\n}\n.tag:before{content:\"\";position:absolute;top:0;right:0;width:0;height:0;display:block;border-left:15px solid transparent;border-bottom:15px solid transparent\n}\n.tag.tag-red:before{border-top:15px solid #f00\n}\n.tag.tag-blue:before{border-top:15px solid #428bca\n}\n.tag.tag-green:before{border-top:15px solid #088c07\n}\nth.shrink{width:0.1%\n}\n", ""]);

// exports
